// extracted by mini-css-extract-plugin
export default {"main":"SubMenuWhiteBackground_main__ySWAB"};